import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

import IMG_1 from "../../../resources/tutorial/Conn_Doctor_Step1.png"
import IMG_2 from "../../../resources/tutorial/Conn_Doctor_Step2.png"
import IMG_3 from "../../../resources/tutorial/Conn_Doctor_Step3.png"

const AddPatientInstructions: InstructionComponentProps = {
    name: "Wie füge ich einen Patienten hinzu?",
    path: "/help/professional/add_patient",
    web: [
        <ImageTextComponent
            col={true}
            text={
                <>
                    Navigieren Sie auf die Startseite, auf der Sie den
                    Patientenüberblick angezeigt bekommen. Sie gelangen auf
                    diese Seite durch einen Klick auf das blaue POKALConnect
                    Logo oben links. Unten in der Spalte "Neue
                    Patientenanfragen" sehen Sie eine Liste von Patient:innen,
                    die Sie hinzufügen können. Damit ein Patient hinzugefügt
                    werden kann, muss dieser zuvor eine Anfrage gestellt haben.
                    Teilen Sie Ihr persönliches Passwort mit Ihren
                    Patient:innen. Dieser ist ein sechstelliger Code aus
                    Bchstaben, den Sie in blauer Schrift unten auf der
                    Patientenüberblick Seite finden. In unserem Beispiel lautet
                    das Passwort "NCICUL".
                </>
            }
            images={[IMG_1]}
        />,
        <ImageTextComponent
            text={
                <>
                    Diesen Schritt muss der oder die Patient:in durchführen.
                    Dafür muss der oder die Patient:in die PokalConnect App
                    öffnen und auf die Startseite navigieren. Dort findet man
                    die Kachel "Arztverbindung". Hier muss das oben gennante
                    Passwort, bestehend aus 6 Buchstaben, eingegeben und auf
                    "Bestätigen" geklickt werden. ACHTUNG: Hier muss kein
                    persönliches Passwort für ein PokalConnect Konto eingegeben
                    werden, sondern das Passwort, das Sie als Ärzt:in mit Ihren
                    Patient:innen teilen. In unserem Beispiel lautet das
                    Passwort "NCICUL".
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            col={true}
            text={
                <>
                    Die letzten beiden Schritte werden nun wieder von Ihnen als
                    Ärzt:in durchgeführt. Navigieren Sie auf die Startseite, auf
                    der Sie den Patientenüberblick angezeigt bekommen. Hier wird
                    Ihnen nun die Patient:in angezeigt, die Sie hinzufügen
                    können. Klicken Sie auf die blaue Schrift mit "Akzeptieren",
                    wenn es sich um die oder den richtige:n Patienten:in
                    handelt. Den Namen des Patienten sehen Sie linksbündig.
                    Sollten Sie Anfragen von Patienten erhalten, die nicht von
                    Ihnen behandelt werden, können Sie diese ablehnen.
                </>
            }
            images={[IMG_2]}
        />,
        <ImageTextComponent
            col={true}
            text={
                <>
                    Nachdem Sie die Anfrage akzeptiert haben, wird der Patient
                    in Ihrer Patientenliste angezeigt. Sollte dies nicht der
                    Fall sein, können Sie durch einen Klick auf die blaue
                    Schrift "Aktualisieren" neben der Überschrift "Neue
                    Patientenanfragen" die Liste aktualisieren. Nun wird Ihnen
                    der oder die Patient:in in Ihrer Patientenliste angezeigt.
                </>
            }
            images={[IMG_3]}
        />
    ]
}

export default AddPatientInstructions
